import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const ClaimBtn = styled(Button)({
  height: "48px",
  lineHeight: "48px",
  maxHeight: "48px",
  color: "#22D758",
  fontSize: 14,
  width: "100%",
  fontFamily: "Gill Sans",
  textTransform: "uppercase",
  background: "rgba(34, 215, 88, 0.2)",
  border: "none",
  borderRadius: "8px",
  "&:hover": {
    background: "rgba(34, 215, 88, 0.5)",
    color: "#22D758",
  },
});
